const tab = {
  styleOverrides: {
    root: {
      textTransform: "initial",
    },
  },
};

export default tab;
